import { Box, VStack, Text, Heading, Button, Flex, Spinner } from '@chakra-ui/react';
import SearchBetaSiteCard from '../search-beta/SearchBetaSiteCard';
import { useState } from 'react';

const AIResponseSearchResults = ({ searchResults, searchQuery, groundingMetadata, initialLimit = 3 }) => { // Added groundingMetadata prop
  const [limit, setLimit] = useState(initialLimit);
  const [loading, setLoading] = useState(false);
  
  if (!searchResults || !searchResults.length) {
    return <Text>No results found for "{searchQuery}"</Text>;
  }
  
  const showLoadMore = searchResults.length > limit;
  const displayedResults = searchResults.slice(0, limit);
  
  const handleLoadMore = () => {
    setLoading(true);
    // Simulate loading delay for better UX
    setTimeout(() => {
      setLimit(prev => prev + 3);
      setLoading(false);
    }, 300);
  };
  
  return (
    <Box borderRadius="md" bg="gray.50" p={4} my={4}>
      <Heading size="md" mb={3}>Search Results for "{searchQuery}"</Heading>
      <VStack spacing={4} align="stretch">
        {displayedResults.map((result, index) => (
          <SearchBetaSiteCard
            key={index}
            site={result}
            groundingMetadata={groundingMetadata} // Pass groundingMetadata down
          />
        ))}
      </VStack>
      
      {showLoadMore && (
        <Flex justifyContent="center" mt={4}>
          <Button 
            onClick={handleLoadMore}
            isLoading={loading}
            loadingText="Loading"
            variant="outline"
            colorScheme="blue"
          >
            Load More Results
          </Button>
        </Flex>
      )}
    </Box>
  );
};

export default AIResponseSearchResults;